import React from "react";
import Axios from "axios";
import AsyncStorage from '@react-native-async-storage/async-storage';

//context api:  
//https://medium.com/datadriveninvestor/getting-started-w-reacts-context-api-f60aa9be758f

const storeContext = React.createContext();
export const Consumer = storeContext.Consumer;

export class Provider extends React.Component {
	constructor(props) {
		super(props); 
		let restType = this.getRestType(props.router.match.path);
		let route = props.router.match.path;
		let slug = props.router.match.params.slug ? props.router.match.params.slug : '';
		let timer = null;
		this.state = {
			newPage:true,
			prevSlug:null,
			slug: slug,
			restType: restType,
			lastRestType:null,
			route: route,
			posts: [], 
			siteLoaded: false,
			pageLoaded: false,
			currentPage: 1, 
			totalPages: 0,      
			appError : '',
			frmMsg: '',
			projectScroll:0,
			menu: {
				open: 			false,
				json: 			null,
				menuFetched: 	false,
				location: 		'/',
				color: 			'#000',
				bgColor: 		'#FFF',
				hover:			false,
			},
			doScroll: this.doScroll.bind(this),
			getMenu: this.getMenu.bind(this),
			changeMenuColour: this.changeMenuColour.bind(this),
			toggleMenu: this.toggleMenu.bind(this)
		};
	}
		
	getRestType (path){
		let restType = '';
		switch(path){   
			case '/':
				restType = 'front';
				break;  
			case '/project/:slug':
				restType = 'project';
				break;
			default:
				restType = 'page';
			break;
		}
		return restType;
	}

	componentDidMount(){ 
    	this.getPosts(this.buildUrl());   
    	document.addEventListener('scroll', this.doScroll);  
	}

	componentDidUpdate(prevProps){ 
		if(prevProps.router.location.pathname.split('#')[0] !== this.props.router.location.pathname.split('#')[0]){  
			let prev = prevProps.router.location.pathname.split('#')[0];
			let current = this.props.router.location.pathname.split('#')[0];
			if (prev !== current) {
				this.setState({newPage: true});
			} else {
				this.setState({newPage: false});
			}
			
			let curProps 	= this.props.router.match; 
			let prevSlug 	= prevProps.router.match.params.slug ? prevProps.router.match.params.slug : '';
			
			this.setState({
				currentPage: 	1, 
				lastRestType: 	this.state.restType,
				restType: 		this.getRestType(curProps.path), 
				slug: 			this.props.router.match.params.slug ? this.props.router.match.params.slug : '',
				prevSlug: 		prevProps.router.match.params.slug ? prevProps.router.match.params.slug : '',
			},function(){
				this.getPosts(this.buildUrl()); 
			})
		} else {
			if (this.props.router.location.hash.split('#')[1] === 'info') {
				window.scroll({
					behavior: 'smooth',
					left: 0,
					top: window.innerHeight
  				});
			}
		}
	}
	
	doScroll=(event)=>{
		if (this.state.slug === 'projects') {
			this.setState({
				projectScroll : window.scrollY
			});
		}
	}
	
	
	getMenu(url) {
		let self = this;
		let menu = this.state.menu;
		if (menu.json === null && menu.menuFetched === false) {
			menu.menuFetched = true;
			self.setState({
				menu : menu
			});
			Axios.get(url).then((response)=>{
				menu.json = response.data[0];
				self.setState({
					menu : menu
				});
			}); 
		}
	}
	
	changeMenuColour(color, bgColor, hover) {
		let menu = this.state.menu;
		if (color == 'light') {
			menu.color 	= '#FFF';
		} else if (color == 'dark') {
			menu.color 	= '#2c2c2c';
		} else {
			menu.color = color;
		}
		menu.bgColor 	= bgColor;
		menu.hover 		= hover;
		this.setState({menu: menu});
	}
	
	toggleMenu() {
		let menu = this.state.menu;
		if (menu.open === false) {
			menu.open = true;
		} else {
			menu.open = false;
		}
		this.setState({menu: menu});
	}

	buildUrl(){
		let url = '/wp-json/penfold/v1/';  
		switch(this.state.restType){   
			case 'front': 
				url += 'front';
				break;  
			case 'project': 
				url += 'project/';
				url += this.state.slug
				break;
			case 'page': 
				default: 
				url += 'page/';
				url += this.state.slug
				break;        
		}
		return url;
	}

	getPosts (url){
		
		let self = this;
		let wait = 0;
		if (document.documentElement.classList.contains('state-site-loaded')) {
			wait = 500;	
		}
		let slug = this.state.slug;
		let lastRestType = this.state.lastRestType;
		setTimeout(function(){
			
			Axios.get(url).then((response)=>{
				let post = response.data[0];
				if (post.accent_color) {
				    document.getElementsByClassName('c-cover')[0].style.backgroundColor = post.accent_color;
			    }
			    let logoColor = 'black';
			    document.documentElement.classList.remove('state-custom-logo-color');
			    if (post.logo_color) {
				    document.documentElement.classList.add('state-custom-logo-color');
				    logoColor = post.logo_color;
			    } else if (post.accent_colour_text == 'light') {
				    
				    logoColor = 'white';
			    }
			    document.documentElement.style.setProperty('--logo-color', logoColor);
			    if (slug == 'projects' && lastRestType === 'project') {
					wait = 0;
			    } else {
				    document.documentElement.classList.remove('state-page-loaded');
			    }
			    setTimeout(function(){
				    Axios.get(url).then((response)=>{
						self.setState({
							posts : response.data, 
							totalPages : response.headers['x-wp-totalpages']
						},function(){   
							document.documentElement.classList.remove('state-reverse-header');
							if (slug == 'projects' && lastRestType === 'project') {
								
							} else {
								document.documentElement.classList.remove('state-page-loaded');
							}
							
							let location = window.location + '';   
							let menu = this.state.menu;
							menu.open = false;
							menu.location = window.location.pathname + '';    
							setTimeout(() => this.setState({
								pageLoaded 	: true,
								siteLoaded 	: true,
								menu 		: menu
							}), 10);
							if (slug == 'projects' && lastRestType === 'project') {
								setTimeout(() => {
									window.scrollTo(0,this.state.projectScroll);
								}, 100);
							} else {
								if (document.documentElement.classList.contains('state-site-loaded')) {
									setTimeout(function(){
										document.documentElement.classList.add('state-page-loaded');
										window.scrollTo(0,0);
									}, 1250);
								} else {
									document.documentElement.classList.add('state-site-loaded');
									setTimeout(function(){
										document.documentElement.classList.add('state-page-loaded');
										window.scrollTo(0,0);
									}, 2500);
								}
							}
						});
					}).catch(function(error){
						self.appError = 'An unexpected error occurred';
					});
				}, wait);  
			}).catch(function(error){
				self.appError = 'An unexpected error occurred';
			});  
		}, 0);
	}

	render() {
    	return (
			<storeContext.Provider value={this.state}>
				{this.props.children}
			</storeContext.Provider>
		);
	}
}